<script setup>
import Button from 'next/button/Button.vue';
import PaginationFooter from 'next/pagination/PaginationFooter.vue';

defineProps({
  headerTitle: { type: String, required: true },
  currentPage: { type: Number, default: 1 },
  itemsPerPage: { type: Number, default: 15 },
  totalItems: { type: Number, default: 0 },
  showPaginationFooter: { type: Boolean, default: false },
  hasAppliedFilters: { type: Boolean, default: false },
});

const emit = defineEmits(['update:current-page', 'filter']);

const handlePageChange = page => {
  emit('update:current-page', page);
};
</script>

<template>
  <section
    class="flex w-full h-full gap-4 overflow-hidden justify-evenly bg-n-surface-1"
  >
    <div class="flex flex-col gap-6 w-full h-full transition-all duration-300">
      <header class="sticky top-0 z-10">
        <div
          class="flex items-start sm:items-center justify-between w-full py-6 px-6 gap-2 mx-auto max-w-[60rem]"
        >
          <span class="text-xl font-medium truncate text-n-slate-12">
            {{ headerTitle }}
          </span>

          <div class="relative">
            <Button
              id="toggleAuditTrailFilterButton"
              icon="i-lucide-list-filter"
              color="slate"
              size="sm"
              class="relative w-8"
              variant="ghost"
              @click="emit('filter')"
            >
              <div
                v-if="hasAppliedFilters"
                class="absolute top-0 right-0 w-2 h-2 rounded-full bg-n-brand"
              />
            </Button>
            <slot name="filter" />
          </div>
        </div>
      </header>

      <main class="flex-1 overflow-y-auto">
        <div class="w-full mx-auto max-w-[60rem]">
          <slot />
        </div>
      </main>

      <footer v-if="showPaginationFooter" class="sticky bottom-0 z-0 px-4 pb-4">
        <PaginationFooter
          current-page-info="WGPT_AUDIT_TRAIL.PAGINATION_FOOTER.SHOWING"
          :current-page="currentPage"
          :total-items="totalItems"
          :items-per-page="itemsPerPage"
          @update:current-page="handlePageChange"
        />
      </footer>
    </div>
  </section>
</template>
